import { render, staticRenderFns } from "./ChainsPreview.vue?vue&type=template&id=65343871&lang=pug&"
import script from "./ChainsPreview.vue?vue&type=script&lang=js&"
export * from "./ChainsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports